import { ReactNode } from 'react';
import { message } from 'antd';
import IAuthUser from '@interfaces/IAuthUser';

class Storage {
  public read(key: string) {
    return localStorage.getItem(key);
  }

  public readObject(key: string) {
    const text = this.read(key);
    let obj: Record<string, any> = {};
    try {
      obj = JSON.parse(text as string);
    } catch (error) {
      message.error(error as ReactNode);
    }
    return obj;
  }

  public write(key: string, data: string) {
    localStorage.setItem(key, data);
  }

  public writeObject(key: string, data: any | null) {
    const text = JSON.stringify(data);
    this.write(key, text);
  }

  public remove(key: string) {
    localStorage.removeItem(key);
  }

  public readUser(): IAuthUser {
    return this.readObject('user') as IAuthUser;
  }
}

const storage = new Storage();
export default storage;
